module.exports = __webpack_public_path__ + "static/Student3-1946049ea7d8cf4201f151cccd501bdc.jpg";